import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Alert } from './slice.types';

export interface AlertsState {
  queue: Alert[];
}

export const alertsInitialState: AlertsState = {
  queue: [],
};

const slice = createSlice({
  name: 'alerts',
  initialState: alertsInitialState,
  reducers: {
    addAlertAction(state, { payload }: PayloadAction<Alert>) {
      state.queue.push(payload);
    },
    removeAlertAction(state, { payload }: PayloadAction<number>) {
      state.queue.splice(payload, 1);
    },
  },
});

export const { addAlertAction, removeAlertAction } = slice.actions;

export const alertsReducer = slice.reducer;
